module.exports = __webpack_public_path__ + "static/media/soke.d356bdd5.m4a";